import { Component, Input, ChangeDetectionStrategy, inject } from '@angular/core';
import { GridComponent } from '@syncfusion/ej2-angular-grids';
import { CommonService } from '../../services/common.service';

@Component({
    selector: 'app-column-chooser',
    templateUrl: './column-chooser.component.html',
    styleUrls: ['./column-chooser.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ColumnChooserComponent {
    private commonService = inject(CommonService);

    @Input() grid: GridComponent;

    onClick() {
        // Showing or hiding a column while a row is edited leaves the edit row's fields under the wrong columns.
        if (this.grid?.isEdit) {
            this.commonService.showNotification('warning', 'Save or cancel the row you are editing before showing or hiding columns.', 'center', 5000);
            return;
        }
        this.grid.columnChooserModule.openColumnChooser(0, 40);
        document.getElementById(this.grid?.element?.id+"_ccdlg_title")?.classList.add('d-none');

    }
}
